import * as React from "react";
import { styled } from "@mui/material";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const base = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 61,
	height: 23,
	fill: "none",
	viewBox: "0 6 61 29",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#EC4949",
		d: "M14.87 29c3.62-13.24 8-18.7 19.13-25.69L27.68 0C13.66 4.09 8.04 9.16 0 20.61h11.44L14.87 29Z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#EC4949",
		d: "M46.13 29c-3.62-13.24-8-18.7-19.13-25.69L33.32 0C47.34 4.09 52.96 9.16 61 20.61H49.56L46.13 29Z"
	})]
});
const SvgRibbonBigBottom = styled(base)({});
export default SvgRibbonBigBottom;
